import script from "./BudgetWeekPayloadContent.vue?vue&type=script&setup=true&lang=js"
export * from "./BudgetWeekPayloadContent.vue?vue&type=script&setup=true&lang=js"

import "./BudgetWeekPayloadContent.vue?vue&type=style&index=0&id=461654ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-461654ac"]])

export default __exports__